import React from 'react';

export default function DokumenSiswa() {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Dokumen Siswa</h1>
      <p className="text-gray-500">Halaman Dokumen Siswa</p>
    </div>
  );
}
